import React from 'react';

const Button = ({ className = '', children, ...props }) => {

    const buttonClass = [
        'button',
        className,
    ].join(' ').trim();

    return (
        <button
            {...props}
            type="button"
            className={buttonClass}>
            {children}
        </button>
    )
};

export { Button };
